import dayjs from 'dayjs'

export const dateFormat = (date) => {
  return dayjs(date).format('DD.MMM.YYYY')
}

export const scrollPageTo = (navEl) => {
  const element = document.querySelector(`#${navEl}`)
  element.scrollIntoView({ behavior: 'smooth' })
}

export const vaildEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

export const checkEmail = (email) => {
  const re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i
  return re.test(email.toLowerCase())
}

export const sliceIntoChunks = (arr, chunkSize) => {
  const res = []
  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize)
    res.push(chunk)
  }
  return res
}

export const toForm = async (page) => {
  const blackList = [
    'Blog',
    'Article',
    'TagArticle',
    'Policy',
    'ArticleTest',
    'PrivacyPolicy',
    'ConsumerRights',
    'MemberTerms',
  ]
  if (!blackList.includes(page.value)) scrollPageTo('form')
  else {
    await router.push('/#form')
    setTimeout(() => {
      scrollPageTo('form')
    }, 300)
  }
}

export const toTop = async () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}


export const planCardGap = (w) => {
  if (w < 375) {
    return 1
  } else if (w < 400) {
    return 1.2
  } else if (w < 440) {
    return 1.3
  } else if (w < 540) {
    return 1.45
  } else if (w < 675) {
    return 1.75
  } else if (w < 780) {
    return 2.2
  } else if (w < 780) {
    return 2.3
  } else if (w <= 900) {
    return 1.8
  } else if (w <= 1040) {
    return 2.2
  } else {
    return 2.5
  }
}